export const REGISTRATION_SUCCESS = "REGISTRATION_SUCCESS"
